module.exports = __webpack_public_path__ + "img/at-the-rate-icon.9a65bfdf.svg";